import React, { Component } from 'react';
import SeatContainer from '../seat/seatContainer';
import imgUser from "../../img/no-profile.png";
import InfoCommon from './infoCommon';

class StudentInfo extends Component {
    state = {
        rowSanpNum: 2
    }
    render() {
        //console.log(`currentClass in studentInfo: ${this.props.currentClass}`);
        return (
            <section className={this.props.currentClass ? "popup-show student-info-popup popup-wrap flex-column align-items-center justify-content-center position-absolute" : "student-info-popup popup-wrap flex-column align-items-center justify-content-center position-absolute"}>
                <article className="popup-container d-flex flex-column">
                    <div className="popup-header d-flex align-items-center">
                        <h1 className="title w-100 m-0 text-center">응시자 정보 상세</h1>
                        <button type="button" className="btn close-btn info-close-btn" onClick={this.props.onClose}>
                            <span className="icon-wrap">
                                <svg className="icon close-btn" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
                                    <path d="M153.212,158l4.537-4.537a.857.857,0,0,0-1.212-1.212L152,156.788l-4.537-4.537a.857.857,0,0,0-1.212,1.212L150.788,158l-4.537,4.537a.857.857,0,0,0,1.212,1.212L152,159.212l4.537,4.537a.857.857,0,0,0,1.212-1.212Z" transform="translate(-140 -146)" fill="#fff"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <ul className="popup-body m-0">
                        <li className="main-bg d-flex flex-column align-items-center justify-content-between">
                            <div className="info-card table-wrap w-100">
                                <table>
                                    <colgroup>
                                        <col width="26%" />
                                        <col width="24%" />
                                        <col width="50%" />
                                    </colgroup>
                                    <tbody>
                                        <InfoCommon Sitnum={this.props.Sitnum} mb_id = {this.props.mb_id} mb_name={this.props.mb_name} test_name={this.props.test_name} rowSanpNum={this.state.rowSanpNum} />
                                        <tr>
                                            <th className="title">생년월일</th>
                                            <td>{this.props.mb_birth}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="btn-wrap">
                                <button type="button" className="btn main-btn close-btn" onClick={this.props.onClose}>확인</button>
                            </div>
                        </li>
                    </ul>
                </article>
            </section>
        );
    }
}

export default StudentInfo;